/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popTipTaskDetail.vue?vue&type=template&id=473ca9c2&scoped=true"
import script from "./popTipTaskDetail.vue?vue&type=script&lang=js"
export * from "./popTipTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./popTipTaskDetail.vue?vue&type=style&index=0&id=473ca9c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473ca9c2",
  null
  
)

export default component.exports